import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import React, { useEffect, useState } from "react";
import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { FooterButtonCenter } from "../../../components/FooterButton/FooterButton";
import Media from "../../../components/Media/Media";
export default function P250({ footer, dataTable = [], onGenPhotoUpdate, tabCode }) {
    const [confirmDialog, setConfirmDialog] = useState({ dialog: false, data: {} });
    const [photoTypeDesc, setPhotoTypeDesc] = useState("");

    useEffect(() => {
        if (dataTable && dataTable.length > 0) {
            setPhotoTypeDesc(dataTable[0].photoTypeDesc ? dataTable[0].photoTypeDesc : "");
        } else {
            setPhotoTypeDesc("");
        }
    }, [dataTable]);

    const carouselResponsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 3,
            numScroll: 3,
        },
        {
            breakpoint: "768px",
            numVisible: 2,
            numScroll: 2,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
            numScroll: 1,
        },
    ];

    const footerButton = () => {
        return <FooterButtonCenter onClickCancle={() => setConfirmDialog({ dialog: false })} onClickOk={() => onDelete()} />;
    };

    const onDelete = () => {
        onGenPhotoUpdate(confirmDialog.data, "ลบรายการ");
        setConfirmDialog({ dialog: false });
    };

    const carouselItemTemplate = (data) => {
        return (
            <div className="product-item ">
                <div className="product-item-content" style={{}}>
                    <div className="p-mb-3">
                        <Media
                            path={data.photoPath}
                            alt={data.photoTypeDesc}
                            style={{ width: 200, height: 210 }}
                            // type ={images}
                        />
                    </div>
                    <div>
                        <h6 className="p-mb-2">{data.name}</h6>
                        {/* <label className="p-mb-1">asd</label> */}
                        <div className="car-buttons p-mt-2">
                            <Button type="button" className="p-button-danger p-button" icon="pi pi-trash" onClick={() => setConfirmDialog({ dialog: true, data })}></Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="p-grid p-fluid media-demo">
                <div className="p-col-12">
                    <div className="card">
                        {photoTypeDesc !== "" ? (
                            <>
                                <h4>{photoTypeDesc}</h4>
                                <hr />
                            </>
                        ) : (
                            ""
                        )}
                        <div className="p-grid  p-fluid">
                            {dataTable && dataTable.length > 0 ?
                                <div className="p-col-12 p-md-12" style={{textAlign:'right'}}>
                                    <label className="">จำนวน {dataTable.length} รูปถ่าย</label>
                                </div>
                                :('')
                            }
                            <div className="p-col-12 p-md-12">{dataTable && dataTable.length > 0 ? <Carousel value={dataTable} numVisible={4} numScroll={3} responsiveOptions={carouselResponsiveOptions} itemTemplate={carouselItemTemplate}></Carousel> : ""}</div>
                        </div>
                        <div className="p-grid  p-fluid">{footer()}</div>
                    </div>
                </div>
            </div>

            <DialogConfirm
                visible={confirmDialog.dialog}
                header="แจ้งเตือน"
                modal
                footer={footerButton()}
                onHide={() => setConfirmDialog(false)}
                textContent={`คุณต้องการลบข้อมูล ใช่หรือไม่ ?`}
            />
        </>
    );
}
